import styled from 'styled-components'
import { colors } from 'client/styles'
import { TooltipBase } from 'client/components/Tooltip/styles'

export const StaywalletBase = styled.div`
  align-items: center;
  color: ${colors.grey2};
  display: flex;
  font-size: 14px;
  line-height: 1.2;

  > svg {
    fill: ${colors.magenta};
    flex: 0 0 auto;
    margin-inline-end: 5px;
  }

  > p {
    padding-block: 3px;
    padding-inline: 6px;
  }

  strong {
    color: ${colors.magenta};
  }

  ${TooltipBase} {
    display: flex;
    margin-inline-start: 4px;

    svg {
      fill: ${colors.grey2};
    }
  }
`
